<template>
  <div :class="$style.container">
    <div
      :class="$style.list"
      ref="list"
    >
      <infinite-loading
        v-if="isInited"
        direction="top"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
        :class="$style.infiniteLoading"
      >
        <Spinner slot="spinner" />
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      <MoodMessage
        v-for="(message) in moodList" :key="message.messageId"
        :message="message"
        :firstMessagesByDay="firstMessagesByDay"
        :class="$style.message"
      />
    </div>
    <Fab :class="[$style.createButton]" @click.native="$modal.show('set-status')">
      <BaseIcon name="plus-circle" />
    </Fab>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import MoodMessage from './MoodMessage'
import Fab from '@/components/Fab'
import { startOfDay } from 'date-fns'

const LIMIT = 20

export default {
  name: 'mood-view',
  components: {
    InfiniteLoading,
    Spinner,
    MoodMessage,
    Fab
  },
  data () {
    return {
      infiniteId: +new Date(),
      page: 0,
      isInited: false
    }
  },
  async created () {
    await this.fetchMoods()
    this.$nextTick(() => {
      this.goBottom()
    })
    this.isInited = true
  },
  computed: {
    ...mapGetters({
      moodList: 'entities/moodMessages/list'
    }),
    firstMessagesByDay () {
      return this.moodList.reduce((res, message) => {
        const dayBeginTimestamp = startOfDay(new Date(message.createdTs)) * 1
        const savedMessage = res[dayBeginTimestamp]
        if (!savedMessage || +new Date(message.createdTs) < +new Date(savedMessage.createdTs)) {
          res[dayBeginTimestamp] = message
        }
        return res
      }, {})
    }
  },
  // watch: {
  //   'profileNickname': {
  //     immediate: true,
  //     handler (nickname) {
  //       this.page = 0
  //       this.infiniteId += 1
  //       this.fetchProfile(nickname)
  //     }
  //   }
  // },
  methods: {
    ...mapActions({
      fetchMoods: 'entities/moodMessages/fetch'
    }),
    goBottom () {
      if (!this.$refs.list) return
      this.$refs.list.scrollTop = this.$refs.list.scrollHeight
    },
    async infiniteHandler ($state) {
      const posts = await this.fetchMoods({
        limit: LIMIT,
        page: this.page
      })
      if (posts.length < LIMIT) {
        $state.complete()
      } else {
        $state.loaded()
        this.page += 1
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  flex-grow: 1;
}
.chatButton {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.list {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
}
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
}
.createButton {
  position: absolute;
  bottom: 15px;
  right: 15px;
  font-size: 22px;
  width: 40px;
}
</style>
